<template>
  <div>
    <a-table :columns="columns"
             :dataSource="data"
             :loading="loading"
             :pagination="pagination"
             @change="handleTableChange"
             class="bot-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <div slot="user_info" slot-scope="text">
        {{ text.nickname + '（' + text.username + '）'}}
      </div>
      <div slot="obj_list" slot-scope="text">
        <div v-for="client in text" :key="client.nickname" class="avatar-36-con" style="display: inline-flex; margin-right: 5px">
          <img class="avatar" :src="client.avatar_url"/>
          <div class="nickname">{{client.nickname + (client.username ? '（' + client.username + '）' : '')}}</div>
        </div>
      </div>
      <span slot="data" slot-scope="text, record" style="display: inline-flex; align-items: center">
        <span v-if="record.log_type === 'edit_balance' "> {{ '增加 ' + text.balance + ' 积分'}} </span>
        <div v-if="record.log_type === 'edit_chatroom_count' "> {{ '修改群上限到 ' + text.chatroom_count }} </div>
        <span v-if="record.log_type === 'set_vip' "> {{ text.vip === 2 ? '设置 VIP' : '取消 VIP' }} </span>
        <span v-if="record.log_type === 'reset_free_chatroom' "> {{ '重置免费一个群' }} </span>
        <span v-if="record.log_type === 'edit_batch_send_max_count' "> {{ '修改群发上限到 ' + text.new_batch_send_max_count  }} </span>
        <span v-if="record.log_type === 'edit_everyday_batch_send_max_count' "> {{ '修改每日群发上限到 ' + text.new_everyday_batch_send_max_count  }} </span>
      </span>
    </a-table>
  </div>
</template>

<script>
const LOG_TYPE = {
  'edit_balance': '修改积分',
  'edit_chatroom_count': '修改群上限',
  'set_vip': '修改 VIP',
  'reset_free_chatroom': '重置免费一个群',
  'edit_batch_send_max_count': '修改群发上限',
  'edit_everyday_batch_send_max_count': '修改每日群发上限',
}
const axios = require('axios')
export default {
  name: 'LogManage',
  data () {
    return {
      getLogsUrlPostFix: 'get_logs',
      pagination: {
        hideOnSinglePage: true,
        // showTotal: total => `共 ${total} 个群`,
        pageSize: 20,
        current: 1
      },
      data: [],
      loading: false,
      columns: [{
        title: '操作员',
        dataIndex: 'user_info',
        scopedSlots: { customRender: 'user_info' },
        filters: [{
          text: 'Chang',
          value: '18840825366'
        }, {
          text: 'David',
          value: '15210725689'
        }, {
          text: 'Ada',
          value: '13752069925'
        }, {
          text: 'Neil',
          value: '18500865569'
        }, {
          text: 'Harry',
          value: '18811595595'
        }, {
          text: 'Arthas',
          value: '18810528203'
        }, {
          text: 'Sam',
          value: '15510704300'
        }, {
          text: 'Cyan',
          value: '15207146090'
        }, {
          text: 'Gina',
          value: '13132267181'
        }, {
          text: 'Outman',
          value: '15010263732'
        }, {
          text: 'Caiqiong',
          value: '13752580651'
        }, {
          text: 'Deyuan',
          value: '18340866980'
        }, {
          text: 'T-mac',
          value: '18611180242'
        }, {
          text: 'Scofield',
          value: '18600191949'
        }, {
          text: 'Zhiming',
          value: '18516945130'
        }, {
          text: 'Caiqiong',
          value: '13752580651'
        }, {
          text: 'Zhangbin',
          value: '18811389915'
        }, {
          text: 'Eric',
          value: '18810267786'
        }, {
          text: 'Ganyan',
          value: '18801177927'
        }]
      }, {
        title: '类型',
        dataIndex: 'log_type_show',
        filters: [{
          text: '修改积分',
          value: 'edit_balance'
        }, {
          text: '修改群上限',
          value: 'edit_chatroom_count'
        }, {
          text: '修改 VIP',
          value: 'set_vip'
        }, {
          text: '重置免费一个群',
          value: 'reset_free_chatroom'
        }, {
          text: '修改群发上限',
          value: 'edit_batch_send_max_count'
        }, {
          text: '修改每日群发上限',
          value: 'edit_everyday_batch_send_max_count'
        }]
      }, {
        title: '详情',
        dataIndex: 'data',
        scopedSlots: { customRender: 'data' }
      }, {
        title: '操作对象',
        dataIndex: 'obj_list',
        scopedSlots: { customRender: 'obj_list' }
      }, {
        title: '创建时间',
        dataIndex: 'create_time'
      }
      // , {
      //   title: '操作',
      //   dataIndex: 'actions',
      //   scopedSlots: { customRender: 'actions' }
      // }
      ],
      logTypeList: [],
      usernameList: []
    }
  },
  computed: {
    params: function () {
      // console.log('filter', this.filters)
      return {
        // results: this.pagination.pageSize,
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
        log_type_list: this.logTypeList,
        username_list: this.usernameList
        // chatroom_nickname: this.searchChatroomNickname,
        // owner_nickname: this.searchOwnerNickname,
        // level: (this.filters.level || []).map(item => parseInt(item)),
        // group: (this.filters.group || []).map(item => parseInt(item)),
        // order_by: this.order_by
      }
    },
    getLogsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getLogsUrlPostFix
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    handleTableChange (pagination, filters, sorter) {
      // console.log('handleTableChange')
      const pager = {...this.pagination}
      pager.current = pagination.current
      this.pagination = pager
      // console.log('sorter', sorter)
      // const { columnKey, order } = sorter
      // this.order_by = {}
      // if (columnKey !== undefined) {
      //   this.order_by[columnKey] = 'asc'
      //   if (order === 'descend') {
      //     this.order_by[columnKey] = 'desc'
      //   }
      //   // console.log('sorter', sorter, columnKey, order)
      // }
      // console.log('filters', filters)
      // this.filters = filters
      this.logTypeList = filters['log_type_show']
      this.usernameList = filters['user_info']
      this.fetch()
    },
    fetch () {
      // console.log('fetch')
      console.log('params:', this.params)
      this.loading = true
      axios.post(this.getLogsUrl, {
        token: sessionStorage.token,
        ...this.params
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            const pagination = {...this.pagination}
            pagination.total = data.data.content.total_count
            let logList = data.data.content.log_list
            let dataList = []
            logList.forEach((item) => {
              let dataJson = JSON.parse(item.data)
              let createTime = item.create_time
              let userInfo = {
                username: item.username,
                nickname: item.nickname
              }
              dataList.push({
                user_info: userInfo,
                log_type_show: LOG_TYPE[item.log_type],
                ...item,
                data: dataJson,
                obj_list: item.obj_list.splice(0, 3),
                create_time: this.transform(createTime, 'yyyy-MM-dd hh:mm:ss')
              })
            })
            this.loading = false
            // console.log('dataList', dataList)
            this.data = dataList
            this.pagination = pagination
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    transform (value, fmt, ...args) {
      if (typeof value === 'number') {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11) value *= 1000

        let date = new Date(value)
        var o = {
          'M+': date.getMonth() + 1, // 月份
          'd+': date.getDate(), // 日
          'h+': date.getHours(), // 小时
          'm+': date.getMinutes(), // 分
          's+': date.getSeconds(), // 秒
          'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay()
        }
        var weekMap = [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ]
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt) && k !== 'W') {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
          }
          if (new RegExp('(' + k + ')').test(fmt) && k === 'W') {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]])
          }
        }
        return fmt
      } else return ''
    }
  }
}
</script>

<style scoped>

</style>
